import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { paymentApi } from 'store/paymentApi';

export const usePrefetch = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(paymentApi.endpoints.getDepositMethods.initiate());
      dispatch(paymentApi.endpoints.getWithdrawMethods.initiate());
    }
  }, [isAuthenticated, dispatch]);
};
